"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.getSplitButtonUtilityClass = getSplitButtonUtilityClass;
var _base = require("@ori-ui/mui-bundle/base");
function getSplitButtonUtilityClass(slot) {
  return (0, _base.generateUtilityClass)('OriMuiSplitButton', slot);
}
const splitButtonClasses = (0, _base.generateUtilityClasses)('OriMuiSplitButton', ['root', 'button', 'content', 'colorPrimary', 'colorError', 'fullWidth', 'sizeMedium', 'sizeSmall', 'disabled', 'loading', 'edgeEnd', 'edgeStart']);
var _default = exports.default = splitButtonClasses;
//# sourceMappingURL=splitButtonClasses.js.map